import shelf from "@tumbodash/gameShelf/client";
import { menu } from "../nodes/index.js";
import { Session, Loading } from "../index.js";
import { log } from "@tumbodash/browserPackages";

// Initialization object
async function launch(sessionId: string) {
	log.sessionFx("(client/game/launch)");
	// Idempotency lives in the lifecycle machine (game/lifecycle.ts) — by the
	// time this runs, the session is guaranteed to be transitioning to launched.
	var session = Session.get(sessionId);
	if (!session) return;
	// Remove loading animation
	Loading.unmount();
	// Show game mount point
	const gameRoot = document.getElementById(session.mountPoint as string);
	if (!gameRoot) return;
	gameRoot.style.display = "flex";
	gameRoot.style.flexDirection = "column";
	const root = document.getElementById(session.rootPoint as string);
	if (root) root.style.display = "none";

	// Initialize menu
	const menuRef = menu.type3.init(sessionId, session.mountPoint as string);

	// Launch game
	const game = await shelf[session.slug]();
	game.init(sessionId);
	Session.update(sessionId, { menuRef });
}

export default launch;
